<script>
    import Icon from 'svelte-awesome';
    import { home } from 'svelte-awesome/icons';
    const includes = ["Granite countertops with 24” deep cabinets", "Porcelain sinks", "Large Mirror", "Chair and stylist mat for stylists", "WiFi Access", "All utilities included", "LED Lighting", "Create your own schedule.  24/7 365 access", "Set your own prices, & keep 100% of what you earn!", "Personalized space on website", "Fully equipped break room with free laundry facilities", "Decorate your studio to fit your style", "Only work nights, or part time? All studios may be shared!", "On-site Managed", "Collaborate and grow with like-minded professionals"];
</script>
<style>
    ul li{
        line-height: 30px;
    }
    p {
        color: #fff;
    }
</style>
<div id="Lease">
    <h2 class="center section-title">Lease a <span class="emphasis">Studio</span> <Icon data={home} style="height: 40px; width: 40px;"/></h2>
    <div class="sixty-five">
        <p>A La Mode Studios offers private and secure studios that are independently operated. They are designed for independent, motivated salon and spa professionals with the shared dream to own their own salon without the headaches and extreme overhead fees. With affordable rent, and a little up-front costs, you are ready to take this opportunity to expand your business into your own mini salon!</p>
    </div>
    <div>
        <p>Each studio includes what you will need to operate your business:</p>
        <div class="space-around teal-container">
            <ul>
                {#each includes as item}
                    <li>{item}</li>
                {/each}
            </ul>
        </div>
    </div>
</div>